function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-63.000000, -423.000000)",
  fillRule: "nonzero",
  strokeWidth: 1.92
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(48.000000, 341.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "primary-stroke",
  points: "12.5624432 22.8261932 6.99539773 4.75132955 5.00485227 14.4743182 0.0441704545 14.4892159 0.0415568182 13.3436591 4.068125 13.331375 6.77167045 0.129375 12.5028523 18.7382045 15.9235795 6.371 18.7005682 13.3737159 22.9195 13.3436591 22.9273409 14.4892159 17.9251023 14.5263295 16.1175114 9.96945455"
}))))));

const SvgIcTimeline = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "31px",
    viewBox: "0 0 25 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTimeline, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-timeline.259f12ae.svg";
export { ForwardRef as ReactComponent };